(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getting-out-for-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousel = (carousel) => {
      if (carousel.dataset.ready === 'true') return;

      const originalSlides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const track = carousel.querySelector('.getting-out-carousel__track');
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = carousel.dataset.autoplay === 'true' && !prefersReducedMotion && originalSlides.length > 1;
      const delay = Number(carousel.dataset.delay) || 3500;
      let activeIndex = 0;
      let activePhysicalIndex = 0;
      let slides = originalSlides;
      let timer;
      let normalizeTimer;
      let isJumping = false;
      let loopOffset = 0;

      const cleanClone = (clone) => {
        clone.dataset.carouselClone = 'true';
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        return clone;
      };

      if (track && originalSlides.length > 1) {
        const cloneSets = 2;
        const beforeClones = Array.from({ length: cloneSets }).flatMap(() => originalSlides.map((slide) => cleanClone(slide.cloneNode(true))));
        const afterClones = Array.from({ length: cloneSets }).flatMap(() => originalSlides.map((slide) => cleanClone(slide.cloneNode(true))));

        track.prepend(...beforeClones);
        track.append(...afterClones);
        slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
        loopOffset = originalSlides.length * cloneSets;
        activePhysicalIndex = loopOffset;
      }

      const logicalIndex = (slide) => Number(slide?.dataset.slideIndex) || 0;

      const applyState = () => {
        slides.forEach((slide, index) => {
          const active = index === activePhysicalIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const normalizePosition = () => {
        if (!track) return;
        if (originalSlides.length < 2) return;
        if (isJumping) return;
        if (activePhysicalIndex >= loopOffset && activePhysicalIndex < loopOffset + originalSlides.length) return;

        const targetIndex = loopOffset + activeIndex;
        const targetSlide = slides[targetIndex];
        if (!targetSlide) return;

        isJumping = true;
        activePhysicalIndex = targetIndex;
        applyState();
        targetSlide.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        window.setTimeout(() => {
          isJumping = false;
        }, 40);
      };

      const scheduleNormalize = () => {
        window.clearTimeout(normalizeTimer);
        normalizeTimer = window.setTimeout(normalizePosition, prefersReducedMotion ? 60 : 420);
      };

      const closestPhysicalIndex = (targetIndex) => {
        let closestIndex = activePhysicalIndex;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          if (logicalIndex(slide) !== targetIndex) return;

          const distance = Math.abs(index - activePhysicalIndex);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const setActive = (index) => {
        activeIndex = (index + originalSlides.length) % originalSlides.length;
        activePhysicalIndex = closestPhysicalIndex(activeIndex);
        applyState();
        slides[activePhysicalIndex]?.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        scheduleNormalize();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (autoplay) timer = window.setInterval(() => setActive(activeIndex + 1), delay);
      };

      prev?.addEventListener('click', () => {
        setActive(activeIndex - 1);
        start();
      });

      next?.addEventListener('click', () => {
        setActive(activeIndex + 1);
        start();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.carouselDot));
          start();
        });
      });

      const updateFromScroll = () => {
        if (!track) return;
        if (isJumping) return;

        const carouselCenter = track.getBoundingClientRect().left + track.clientWidth / 2;
        let nearestIndex = activePhysicalIndex;
        let nearestDistance = Infinity;

        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.abs(carouselCenter - slideCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        if (nearestIndex !== activePhysicalIndex) {
          activePhysicalIndex = nearestIndex;
          activeIndex = logicalIndex(slides[nearestIndex]);
          applyState();
          scheduleNormalize();
        }
      };

      track?.addEventListener('scroll', () => window.requestAnimationFrame(updateFromScroll), { passive: true });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);

      carousel.dataset.ready = 'true';
      applyState();
      if (slides[activePhysicalIndex]) {
        window.requestAnimationFrame(() => {
          slides[activePhysicalIndex].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        });
      }
      start();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-getting-out-carousel]').forEach(initCarousel);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
